/* eslint-disable no-plusplus */

xplenty.service('xpParamSerializer', [
  function () {
    return function (params) {
      function forEachSorted(obj, iterator, context) {
        const keys = Object.keys(obj).sort();
        for (let i = 0; i < keys.length; i++) {
          iterator.call(context, obj[keys[i]], keys[i]);
        }
        return keys;
      }

      function encodeUriQuery(val, pctEncodeSpaces) {
        return encodeURIComponent(val)
          .replace(/%40/gi, '@')
          .replace(/%3A/gi, ':')
          .replace(/%24/g, '$')
          .replace(/%2C/gi, ',')
          .replace(/%20/g, pctEncodeSpaces ? '%20' : '+');
      }

      function serializeValue(v) {
        if (angular.isObject(v)) {
          return angular.isDate(v) ? v.toISOString() : angular.toJson(v);
        }
        return v;
      }

      if (!params) return '';
      const parts = [];
      forEachSorted(params, function (value, key) {
        if (value === null || angular.isUndefined(value)) return;
        if (angular.isArray(value)) {
          angular.forEach(value, function (v) {
            parts.push(`${encodeUriQuery(key)}=${encodeUriQuery(serializeValue(v))}`);
          });
        } else {
          parts.push(`${encodeUriQuery(key)}=${encodeUriQuery(serializeValue(value))}`);
        }
      });
      return parts.join('&');
    };
  },
]);
